import { useEffect, useMemo, useRef } from 'react';

import styles from './NoizeGraf.module.css';

export const NoizeGraf = ({ noiseLevel = 40 }) => {
  const canvasRef = useRef(null);

  const colors = useMemo(
    () => [
      ...Array(5).fill('#ff0048'), // Красный - сильный (последние 5)
      ...Array(5).fill('#ffff00'), // Желтый - средний (следующие 5)
      ...Array(5).fill('#36ff07'), // Зеленый - слабый (первые 5)
    ],
    []
  );

  // Функция для рисования скругленных прямоугольников
  const roundRect = (ctx, x, y, width, height, radius) => {
    if (height < 2 * radius) radius = height / 2;
    if (width < 2 * radius) radius = width / 2;

    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    ctx.arcTo(x + width, y, x + width, y + radius, radius);
    ctx.arcTo(x + width, y + height, x + width - radius, y + height, radius);
    ctx.arcTo(x, y + height, x, y + height - radius, radius);
    ctx.arcTo(x, y, x + radius, y, radius);
    ctx.closePath();
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const width = canvas.width;
    const height = canvas.height;
    const barCount = 15;
    const barHeight = height / barCount;
    const barSpacing = 10;
    const borderRadius = 20;

    ctx.clearRect(0, 0, width, height);

    const targetLevel = Math.min(Math.max(noiseLevel, 0), 100);

    colors.forEach((color, index) => {
      const y = index * barHeight;
      const actualBarHeight = barHeight - barSpacing;

      // Фон (серая полоса со скруглением)
      ctx.fillStyle = 'rgba(202, 205, 202, 0.5)';
      roundRect(ctx, 0, y, width, actualBarHeight, borderRadius);
      ctx.fill();

      // Расчет заполнения для текущей полосы
      const barNumber = 15 - index;
      const barThreshold = (barNumber / 15) * 100;
      const prevBarThreshold = ((barNumber - 1) / 15) * 100;

      let fillPercentage = 0;
      if (targetLevel >= barThreshold) {
        fillPercentage = 100;
      } else if (targetLevel > prevBarThreshold) {
        fillPercentage = ((targetLevel - prevBarThreshold) / (100 / 15)) * 100;
      }

      // Заполнение цветом ВЕРТИКАЛЬНО снизу вверх внутри полосы
      if (fillPercentage > 0) {
        const fillHeight = actualBarHeight * (fillPercentage / 100);
        const fillY = y + actualBarHeight - fillHeight;

        ctx.fillStyle = color;

        // Создаем маску для скругленного заполнения
        ctx.save();
        roundRect(ctx, 0, y, width, actualBarHeight, borderRadius);
        ctx.clip();

        // Заполняем цветом нужную высоту
        ctx.fillRect(0, fillY, width, fillHeight);
        ctx.restore();
      }
    });
  }, [noiseLevel, colors]);

  return (
    <div className={styles.noizeGraf}>
      <canvas
        ref={canvasRef}
        width={366}
        height={640}
        className={styles.noizeCanvas}
      />
    </div>
  );
};
